import { render } from "./MessagesView.vue?vue&type=template&id=1b4e82b8&scoped=true"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"

import "./MessagesView.vue?vue&type=style&index=0&id=1b4e82b8&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4e82b8"]])

export default __exports__